export const MAX_BYTES = 5 * 1024 * 1024;

export const ALLOW = ["image/jpeg", "image/png", "image/webp"];

export function normalizeKey(x) {
    if (!x) return "";
    if (typeof x === "string") return x.replace(/^\/+/, "");
    return String(x.key || x.url || "").replace(/^\/+/, "");
}

export function uniqPush(arr = [], key) {
    const k = String(key || "");
    if (!k) return arr;
    return arr.includes(k) ? arr : [...arr, k];
}

export function moveToFront(arr = [], index) {
    const a = Array.isArray(arr) ? arr : [];
    const i = Number(index);
    if (!Number.isFinite(i) || i <= 0 || i >= a.length) return a;

    const next = [...a];
    const [item] = next.splice(i, 1);
    next.unshift(item);
    return next;
}

export function isVerifyOk(res) {
    return Boolean(res && (res.ok === true || res.success === true));
}

export function dedupeByKey(items = []) {
    const seen = new Set();
    const out = [];

    for (const it of Array.isArray(items) ? items : []) {
        const key = String(it?.key || it?.url || "");
        if (!key) continue;
        if (seen.has(key)) continue;
        seen.add(key);
        out.push({ ...it, key });
    }

    return out;
}
